module.exports = __webpack_public_path__ + "static/media/risk--mobile--1.4ebcc4b1.png";